import { ref } from "@vue/composition-api";
import store from "@/store/index"

const useAboutUsPg = () => {

    // base data
    const aboutUsPg = ref(null);
    const loading = ref(false);

    // methods
    const getAboutUsPg = async () => {
        loading.value = true;
        const { data, status } = await store.dispatch("fetchAboutUsPg");
        loading.value = false;
        if (status != 200) return;
        aboutUsPg.value = data;
        return data;
    }

    const updateAboutUsPg = async (aboutUsPg) => {
        loading.value = true;
        const { data, status } = await store.dispatch("updateAboutUsPg", aboutUsPg)
        loading.value = false;
        if (status != 200 && status != 201) return;
        return data;
    }

    return {
        aboutUsPg,
        loading,
        // methods
        getAboutUsPg,
        updateAboutUsPg,
    };
}

export default useAboutUsPg;